module.exports = __webpack_public_path__ + "static/media/banner-bg.87269687.png";